module.exports = __webpack_public_path__ + "media/images/dashboard/july-4th-charity-ride-8bd1bbc95873420126a262289ef21994.jpg";